@if (visible()) {
  <div class="release-onboarding__backdrop" role="presentation">
    <section
      class="release-onboarding__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="release-onboarding-title"
      (click)="$event.stopPropagation()"
    >
      <button
        class="release-onboarding__close"
        type="button"
        [attr.aria-label]="'RELEASE_ONBOARDING.CLOSE' | translate"
        (click)="close()"
      >
        &times;
      </button>

      <header class="release-onboarding__header">
        <span class="release-onboarding__logo" aria-hidden="true">
          <svg viewBox="0 0 48 48" focusable="false">
            <path d="m24 2 5.8 5.2 7.8-1.2 2.4 7.5 7 3.7-2.1 7.6 2.1 7.6-7 3.7-2.4 7.5-7.8-1.2L24 47l-5.8-5.2-7.8 1.2L8 35.5l-7-3.7 2.1-7.6L1 16.6l7-3.7 2.4-7.5 7.8 1.2z" transform="translate(0 0)" />
            <path class="release-onboarding__logo-check" d="m14 24 6.5 6.5L34 17" />
          </svg>
        </span>
        <h2 id="release-onboarding-title">{{ 'RELEASE_ONBOARDING.TITLE' | translate }}</h2>
      </header>

      <nav
        class="release-onboarding__steps"
        [attr.aria-label]="'RELEASE_ONBOARDING.STEPS' | translate"
      >
        <span [class.active]="currentStep() === 0">
          <b>1</b>
          {{ 'RELEASE_ONBOARDING.STEP_PROJECTS' | translate }}
        </span>
        <span [class.active]="currentStep() === 1">
          <b>2</b>
          {{ 'RELEASE_ONBOARDING.STEP_ASSISTANT' | translate }}
        </span>
      </nav>

      @if (currentStep() === 0) {
        <p>{{ (noProjectsAvailable() ? 'RELEASE_ONBOARDING.PROJECTS_DESCRIPTION_NO_PROJECTS' : 'RELEASE_ONBOARDING.PROJECTS_DESCRIPTION') | translate }}</p>
      } @else {
        <p>{{ (noProjectsAvailable() ? 'RELEASE_ONBOARDING.ASSISTANT_DESCRIPTION_NO_PROJECTS' : 'RELEASE_ONBOARDING.ASSISTANT_DESCRIPTION') | translate }}</p>
      }

      @if (currentStep() === 0) {
        <img
          class="release-onboarding__preview"
          [src]="noProjectsAvailable() ? '/images/PROJECTS_DESCRIPTION_NO_PROJECTS.gif' : '/images/PROJECTS_DESCRIPTION.gif'"
          [alt]="'RELEASE_ONBOARDING.IMAGE_ALT' | translate"
        />
      } @else {
        <img
          class="release-onboarding__preview"
          [src]="noProjectsAvailable() ? '/images/ASSISTANT_DESCRIPTION_NO_PROJECTS.gif' : '/images/ASSISTANT_DESCRIPTION.gif'"
          [alt]="'RELEASE_ONBOARDING.IMAGE_ALT' | translate"
        />
      }

      <!-- <label class="release-onboarding__dont-show">
        <input
          type="checkbox"
          [checked]="dontShowForFutureReleases()"
          (change)="dontShowForFutureReleases.set($any($event.target).checked)"
        />
        {{ 'RELEASE_ONBOARDING.DONT_SHOW_AGAIN' | translate }}
      </label> -->

      <div class="release-onboarding__actions">
        @if (currentStep() === 1) {
          <button class="secondary" type="button" (click)="previous()">
            {{ 'RELEASE_ONBOARDING.BACK' | translate }}
          </button>
        } @else {
          <button class="secondary" type="button" (click)="close()">
            {{ 'RELEASE_ONBOARDING.SKIP' | translate }}
          </button>
        }
        <button type="button" (click)="next()">
          {{
            (currentStep() === 0 ? 'RELEASE_ONBOARDING.NEXT' : 'RELEASE_ONBOARDING.FINISH')
              | translate
          }}
        </button>
      </div>
    </section>
  </div>
}
